import { Component, inject } from '@angular/core';
import { TableloansComponent } from './tableloans/tableloans.component';
import { GraphloansComponent } from './graphloans/graphloans.component';
import { StatswidgetComponent } from './statswidget/statswidget.component';
import { AuthService } from '../../core/services/api/auth.service';
import { MARKETING_ROLES } from '../../core/models/constants/roles.constants';

@Component({
    selector: 'app-dashboard',
    imports: [StatswidgetComponent, GraphloansComponent, TableloansComponent],
    templateUrl: './dashboard.html',
    styleUrl: './dashboard.scss'
})
export class Dashboard {
    private readonly authService = inject(AuthService);

    /** Para Marketing se ocultan los cards superiores; solo se muestran Sucursales HOY y Órdenes Emitidas HOY. */
    get isMarketingRole(): boolean {
        return this.authService.hasAnyRole(MARKETING_ROLES);
    }
}
